export default class AccountsSurveyOptionsEdit {

  render() {

    // Toggle Client ID Name field visibility based on displayClientId checkbox
    const $displayClientId = $('#displayClientId');
    if ($displayClientId.length === 0) {
      return;
    }

    // Remove any existing handler for this namespace to avoid duplicates on re-render
    $displayClientId.off('change.accountsSurveyOptionsEdit');

    const toggleClientIdName = function() {
      if ($(this).is(':checked')) {
        $('#clientIdName').removeClass('d-none');
      } else {
        $('#clientIdName').addClass('d-none');
      }
    };

    $displayClientId.on('change.accountsSurveyOptionsEdit', toggleClientIdName);
    toggleClientIdName.call($displayClientId[0]);
  }
  
}